/** PURE_IMPORTS_START ._FromEventObservable PURE_IMPORTS_END */
import { FromEventObservable } from './FromEventObservable';
export var fromEvent = FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map 



//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/rxjs/_esm5/observable/fromEvent.js
// module id = ../../../../rxjs/_esm5/observable/fromEvent.js
// module chunks = vendor